import { render, staticRenderFns } from "./Stack.vue?vue&type=template&id=578c8a02&"
import script from "./Stack.vue?vue&type=script&setup=true&lang=js&"
export * from "./Stack.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Stack.vue?vue&type=style&index=0&id=578c8a02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports